'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _reactRouterRedux = require('react-router-redux');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./FilterButton.scss');

var cn = _bind2.default.bind(styles);

var FilterButton = (_dec = (0, _reactRedux.connect)(null, { pushState: _reactRouterRedux.push }), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(FilterButton, _Component);

  function FilterButton() {
    (0, _classCallCheck3.default)(this, FilterButton);
    return (0, _possibleConstructorReturn3.default)(this, (FilterButton.__proto__ || (0, _getPrototypeOf2.default)(FilterButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(FilterButton, [{
    key: 'onClick',
    value: function onClick() {
      var _props = this.props,
          route = _props.route,
          pushState = _props.pushState,
          onClick = _props.onClick,
          onClickArgs = _props.onClickArgs;

      if (route) {
        pushState(route);
      }
      onClick.apply(undefined, (0, _toConsumableArray3.default)(onClickArgs));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          title = _props2.title,
          iconClass = _props2.iconClass,
          className = _props2.className,
          isActive = _props2.isActive,
          disabled = _props2.disabled,
          responsive = _props2.responsive;

      var filterClass = cn('sorter', {
        active: isActive,
        disabled: disabled,
        responsive: responsive
      }, className);

      return _react2.default.createElement(
        'span',
        { className: filterClass, onClick: this.onClick },
        iconClass && _react2.default.createElement('i', { className: iconClass }),
        _react2.default.createElement(
          'span',
          { className: styles.sorterTitle },
          title
        )
      );
    }
  }]);
  return FilterButton;
}(_react.Component), _class3.propTypes = {
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  iconClass: _propTypes2.default.string,
  isActive: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  onClickArgs: _propTypes2.default.array,
  pushState: _propTypes2.default.func,
  responsive: _propTypes2.default.bool,
  route: _propTypes2.default.string,
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])
}, _class3.defaultProps = {
  onClick: _noop3.default,
  onClickArgs: [],
  responsive: true
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onClick'), _class2.prototype)), _class2)) || _class);
exports.default = FilterButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FilterButton/FilterButton.js
// module id = 349
// module chunks = 1